import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import plantBackgroundImage from "../../assets/images/404-bg.png";
import plantBrokentLink from "../../assets/images/brokent-link.png";
import plantEmptyTower from "../../assets/images/trkr.png"
import ValidateUser from "../../components/ExpireLink";
import { AuthAction } from "../../store/actions";
class ExpiredLink extends Component {
    constructor(props) {
        super(props);

    }
    render() {
        const { storeName, getStoreName } = this.props
        return (
            <Row justify="center">
                <Col xs={22} sm={18} md={12} lg={11} xl={24}>
                    <ValidateUser
                        backgroundImage={plantBackgroundImage}
                        ImageWidth="335px"
                        ImageHeight="204px"
                        brokentLinkImage={plantBrokentLink}
                        emptyTowerImage={plantEmptyTower}
                        trkrText="Oops......"
                        trkrDescription="looks like the link you are looking for has expired!"
                        exitsText="  The page you are looking for no longer exists"
                    />
                </Col >
            </Row >
        );
    }
}

function mapStateToProps(storeState) {
    return {
        loader: storeState?.AuthReducer.loader,
        error: storeState?.AuthReducer.error,
        // storeName: storeState?.AuthReducer.storeInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        // getStoreName: (data) => dispatch(AuthAction.getStoreUrlReq(data)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredLink);
